
import { Component, Prop, Ref, Vue, Watch } from 'vue-property-decorator'
import InvoiceGeneratorDialog from '@/components/Transport/Accounting/InvoiceGeneratorDialog.vue'
import { Invoice } from '@/models/accounting/Invoice'
import Notification from '@/classes/Notification'
import i18n from '@/i18n'
import { GenerateInvoiceData } from '@/utils/invoice'

@Component({
	components: { InvoiceGeneratorDialog }
})
export default class InvoiceGeneratorDialogWrapper extends Vue {
	@Prop({ required: true })
	show!: boolean

	@Prop({ required: true })
	invoiceId!: string

	@Ref('generatorDialog')
	generatorDialogRef!: InvoiceGeneratorDialog

	invoice: Invoice | null = null
	isLoading: boolean = false
	isSubmitting: boolean = false

	async created() {
		await this.loadInvoice()
	}

	@Watch('invoiceId')
	async onInvoiceIdChange() {
		await this.loadInvoice()
	}

	async loadInvoice() {
		if (!this.invoiceId) return
		this.isLoading = true
		try {
			const response = await Invoice.with(['transports', 'transports.documents']).find(this.invoiceId)
			this.invoice = response.getData() as Invoice
		} catch (err) {
            // eslint-disable-next-line
			console.error('Error loading invoice', err)
			await Notification.Error(i18n.t('errors.load_error').toString())
			this.$emit('close')
		} finally {
			this.isLoading = false
		}
	}

	// Validation is the only thing the user waits for; the generate/attachments requests are
	// handed to the parent so the modal can close straight away instead of hanging on the backend.
	//
	// isSubmitting replaces the generating flag that used to gate the button: with nothing
	// awaited here, two clicks would otherwise both emit and generate the PDF twice.
	async handleGenerate(receivedData: GenerateInvoiceData | null) {
		if (!this.invoice || this.isSubmitting) return
		this.isSubmitting = true

		const valid = await this.generatorDialogRef.validate()
		if (!valid) {
			this.isSubmitting = false
			return
		}

		// Stays true on success: the dialog is about to be unmounted by the parent.
		this.$emit('generate-requested', { invoice: this.invoice, receivedData })
	}
}
